<!-- Template -->

<template>
    <table class="table no-header work-orders">
        <tbody>

            <tr v-for="wo in workOrders" :key="wo.id">
                <td><span class="status" :class="wo.className">{{wo.status}}</span></td>
                <td>
                    {{wo.code}} {{wo.name}}
                    <p>{{wo.engineer}}</p>
                </td>
                <td>
                    <p>{{wo.date}}</p>
                </td>
            </tr>
            <tr v-show="workOrders.length <= 0">
                <td>
                    <p>System work orders do not exist.</p>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<!-- Script -->

<script>
    import moment from 'moment';
    export default {
        name: 'SystemWorkOrder',

        props: ['system'],

        data(){
            return{
                workOrders:[]
            }
        },

        created() {              
            var workOrders = this.system.workOrders; 
            if(workOrders.length > 0){
                for(var i = 0; i < workOrders.length; i++){
                    var workOrder = {
                        status:'',
                        code: workOrders[i].workOrderId,
                        name: workOrders[i].type,
                        engineer:workOrders[i].engineer,
                        date:moment(workOrders[i].visitDate).format('DD MMM YYYY'),
                        className: ''
                    };

                    if(workOrders[i].status == 1){
                        workOrder.status = 'Open';
                    }else{
                        workOrder.status = 'Closed';
                    }

                    workOrder.className = workOrder.status.toLowerCase();

                    this.workOrders.push(workOrder);
                }
            } 
        }
    }
</script>

